/* eslint-disable
    func-names,
    no-useless-escape,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const _ = require('lodash');

const DocumentPreviewCtrl = function (Document, ngDialog, benchLocation) {
  this.document = new Document(this.documentId);
  this.rootUrl = benchLocation.apiRoot();

  this.openPreview = function () {
    const pages = _.reduce(
      this.document.file.pages,
      (result, value) => `${result}<img \
ng-src=\"${this.rootUrl}${value.originalView}\" \
ng-click=\"closeThisDialog()\" \
style=\"margin-bottom: -5px; cursor: zoom-out\" \
alt=\"Preview\" />`,
      '',
    );

    return ngDialog.open({
      template: pages,
      plain: true,
      className: 'bl-modal-default',
    });
  };
};

module.exports = DocumentPreviewCtrl;
